module.exports = __webpack_public_path__ + "static/img/1.8b0834b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PdfForm/asset/images/1.jpg
// module id = CeZi
// module chunks = 3